import { render, staticRenderFns } from "./NotesListItem.vue?vue&type=template&id=4e9b7b56"
import script from "./NotesListItem.vue?vue&type=script&lang=js"
export * from "./NotesListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports